// Unpublished Work © 2021-2022 Deere & Company

import {oktaAuth} from '../../factories/okta-config-factory';
import React from 'react';

export const OktaCallback = () => {
    React.useEffect(() => {
        const parseTokens = async () => {
            const {tokens} = await oktaAuth.token.parseFromUrl();

            await oktaAuth.handleLoginRedirect(tokens);
        };

        parseTokens();
    }, []);

    return null;
};
